import React, { Component, PropTypes } from 'react'
import cn from 'classnames'
import { AutoSizer, VirtualScroll } from 'react-virtualized'
import { EasinsureContractsListItem } from './EasinsureContractsListItem'
import { translate } from './translate'
import { iconMap } from './icon-map'
import stylesClient from 'elements/client.scss'
import styles from './EasinsureContractsList.scss'
import 'react-virtualized/styles.css'

export class EasinsureContractsList extends Component {
	constructor(props) {
		super(props)
		this.rowRenderer = this.rowRenderer.bind(this)
	}

	sortFilteredContracts() {
		const { filteredContracts } = this.props
		return filteredContracts.sort((a, b) => {
			if (a.contractState === 'Actief' && b.contractState !== 'Actief') {
				return -1
			}
			if (a.contractState !== 'Actief' && b.contractState === 'Actief') {
				return 1
			}
			return 0
		})
	}

	rowRenderer({ index }) {
		const { onLinkClicked, filteredContracts } = this.props
		const contract = filteredContracts[index]

		return (
			<EasinsureContractsListItem
				contract={contract}
				onLinkClicked={onLinkClicked.bind(null, contract.contractId)}
			/>
		)
	}

	render() {
		const { filter, isPhone } = this.props
		const title = filter ? `${translate('title')} ${translate(iconMap[filter].name)}` : `${translate('all')} ${translate('title')}`
		const contracts = this.sortFilteredContracts()

		return (
			<div className={styles.wrapper}>
				<h3 className={stylesClient.listTitle}>{title}</h3>
				<div className={cn(stylesClient.listWrapper, styles.contractsList)}>
					<AutoSizer>
						{({width, height}) => (
							<VirtualScroll
								className={stylesClient.list}
								height={height}
								width={width}
								rowCount={contracts.length || 0}
								rowHeight={isPhone ? 140 : 120}
								rowRenderer={this.rowRenderer}
							/>
						)}
					</AutoSizer>
				</div>
			</div>
		)
	}
}
EasinsureContractsList.propTypes = {
	filter: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	filteredContracts: PropTypes.array,
	onLinkClicked: PropTypes.func,
	isPhone: PropTypes.bool,
}



// WEBPACK FOOTER //
// ./components/easinsure/contracts/EasinsureContractsList.jsx